import { get } from '../request';

export interface ReviewRating {
    value: number;
    name: string;
    code: string;
    description: string;
}

export interface CycleData {
    cycleId: string;
    cycleName: string;
    reviewRatings: ReviewRating[];
    underReviewTo: string;
}

getCycleData.operation = 'READ';
getCycleData.idFrom = 'ARGS';
export function getCycleData(companyId: string) {
    return get<CycleData[]>('/api/v2/company-analytics/cycle-data/' + companyId);
}
